import React from "react"
import { components } from "@infotech/uikit-select"
import { Box } from "@infotech/uikit-grid"
import cn from "classnames"
import {
  DEFAULT_COLOR,
  makeTransparent,
} from "src/containers/Calendar/helpers/eventToItem"
import styles from "./styles.css"

export const typeCustomOptions = eventTypeFilter => {
  // select type
  const DropdownOption = props => {
    const { color, label, className, value } = props
    return (
      <div className={cn(className, styles[`select-dropdown-option-wrapper`])}>
        {color && (
          <div className={styles[`circle-wrapper`]}>
            <div
              className={styles.circle}
              style={{
                backgroundColor: `${
                  color === `#fff` ? DEFAULT_COLOR : makeTransparent(color, 0.4)
                }`,
              }}
            />
          </div>
        )}
        <div
          className={styles[`select-dropdown-option-label`]}
          style={{
            color:
              eventTypeFilter && value === eventTypeFilter.value
                ? `#fff !important`
                : `#000`,
          }}
        >
          {label}
        </div>
      </div>
    )
  }
  const SingleValue = ({ children, getValue, ...props }) => {
    const value = getValue()[0]
    return (
      <components.SingleValue {...props}>
        {children}
        <DropdownOption className={styles[`select-current-value`]} {...value} />
      </components.SingleValue>
    )
  }

  const Option = ({ data, data: { color }, ...props }) => (
    <Box loose className={!color && styles.AnyOptionSpace}>
      <components.Option data={data} {...props}>
        <DropdownOption {...data} />
      </components.Option>
    </Box>
  )

  const CustomPlaceholder = props => (
    <components.Placeholder
      {...props}
      getStyles={componentName => ({
        ...props.getStyles(componentName, props),
        color: props.selectProps.haveAny
          ? props.getStyles(`option`, props).color
          : `#808080`,
      })}
    />
  )

  return {
    SingleValue,
    Option,
    Placeholder: CustomPlaceholder,
  }
}
